export enum accountState {
    verify = 'VERIFY',
    active = 'ACTIVE',
    notActive = 'NOT-ACTIVE',
    process = 'SIGNUP-PROCESS',
    forgot = 'FORGOT_PASSWORD',
}